import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getApplicantById, removeLessonEntry, updateLessonEntry, updateDrivingLessonEntry, updateApplicant } from 'service/api';
import { matchCourse } from '../util/SearchUtil';
import { hideModal, showModal } from './modal';

// Constants - action names
export const GET_APPLICANT = 'pv-kultu/workItem/GET_APPLICANT';
export const GET_APPLICANT_SUCCESS = 'pv-kultu/workItem/GET_APPLICANT_SUCCESS';
export const GET_APPLICANT_FAILED = 'pv-kultu/workItem/GET_APPLICANT_FAILED';

export const UPDATE_LESSON_ENTRY = 'pv-kultu/workItem/UPDATE_LESSON_ENTRY';
export const UPDATE_LESSON_ENTRY_SUCCESS = 'pv-kultu/workItem/UPDATE_LESSON_ENTRY_SUCCESS';
export const UPDATE_LESSON_ENTRY_FAILED = 'pv-kultu/workItem/UPDATE_LESSON_ENTRY_FAILED';

export const UPDATE_DRIVING_LESSON_ENTRY = 'pv-kultu/workItem/UPDATE_DRIVING_LESSON_ENTRY';
export const UPDATE_DRIVING_LESSON_ENTRY_SUCCESS = 'pv-kultu/workItem/UPDATE_DRIVING_LESSON_ENTRY_SUCCESS';
export const UPDATE_DRIVING_LESSON_ENTRY_FAILED = 'pv-kultu/workItem/UPDATE_DRIVING_LESSON_ENTRY_FAILED';

export const REMOVE_LESSON_ENTRY = 'pv-kultu/workItem/REMOVE_LESSON_ENTRY';
export const REMOVE_LESSON_ENTRY_SUCCESS = 'pv-kultu/workItem/REMOVE_LESSON_ENTRY_SUCCESS';
export const REMOVE_LESSON_ENTRY_FAILED = 'pv-kultu/workItem/REMOVE_LESSON_ENTRY_FAILED';

export const UPDATE_APPLICANT = 'pv-kultu/workItem/UPDATE_APPLICANT';
export const UPDATE_APPLICANT_SUCCESS = 'pv-kultu/workItem/UPDATE_APPLICANT_SUCCESS';
export const UPDATE_APPLICANT_FAILED = 'pv-kultu/workItem/UPDATE_APPLICANT_FAILED';

export const UPDATE_LESSON_ENTRIES_LIST = 'pv-kultu/workItem/UPDATE_LESSON_ENTRIES_LIST';

export const RESET = 'pv-kultu/workItem/RESET';
export const RESET_LESSON_ENTRY = 'pv-kultu/workItem/RESET_LESSON_ENTRY';

export const SELECT_LESSON_ENTRY = 'pv-kultu/workItem/SELECT_LESSON_ENTRY';

export const UPDATE_LESSON_VISIBILITY = 'pv-kultu/workItem/UPDATE_LESSON_VISIBILITY';

// Helpers
const getUpdatedEntryList = (lessonEntry, originalEntries) => {
  const i = originalEntries.map((a) => a.entityId).indexOf(lessonEntry.entityId);
  return [
    ...originalEntries.slice(0, i),
    lessonEntry,
    ...originalEntries.slice(i + 1),
  ];
};

const getFilteredEntryList = (lessonEntryId, originalEntries) => {
  return originalEntries.filter(e => e.entityId !== lessonEntryId);
};

// Initial state
const initialState = {
  selectedApplicant: {
    course: undefined,
    applicant: undefined,
    loading: false,
    error: undefined,
  },
  lessonEntry: {
    loading: false,
    error: undefined,
    selectedEntry: undefined,
  },
  loading: false,
  error: undefined,
  success: false,
  lessonVisibility: {
    showCompulsory: true,
    showAdditional: true,
    showCurrentCourse: true,
    showOtherCourses: [],
  },
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_APPLICANT:
      return Object.assign({}, state, {
        selectedApplicant: {loading: true, error: undefined}
      });
    case GET_APPLICANT_SUCCESS:
      return Object.assign({}, state, {
        selectedApplicant: {
          course: action.course,
          applicant: action.applicant,
          loading: false
        }
      });
    case GET_APPLICANT_FAILED:
      return Object.assign({}, state, {
        selectedApplicant: {
          loading: false,
          error: action.error
        }
      });
    case UPDATE_LESSON_ENTRY:
      return Object.assign({}, state, {
        lessonEntry: {loading: true}
      });
    case UPDATE_LESSON_ENTRY_SUCCESS:
      return Object.assign({}, state, {
        lessonEntry: {loading: true}
      });
    case UPDATE_LESSON_ENTRY_FAILED:
      return Object.assign({}, state, {
        lessonEntry: {loading: true}
      });
    case UPDATE_DRIVING_LESSON_ENTRY:
      return Object.assign({}, state, {
        lessonEntry: {loading: true}
      });
    case UPDATE_DRIVING_LESSON_ENTRY_SUCCESS:
      return Object.assign({}, state, {
        lessonEntry: {loading: false}
      });
    case UPDATE_DRIVING_LESSON_ENTRY_FAILED:
      return Object.assign({}, state, {
        lessonEntry: {loading: false, error: action.error}
      });
    case REMOVE_LESSON_ENTRY:
      return Object.assign({}, state, {
        lessonEntry: {loading: true}
      });
    case REMOVE_LESSON_ENTRY_SUCCESS:
      return Object.assign({}, state, {
        lessonEntry: {loading: false}
      });
    case REMOVE_LESSON_ENTRY_FAILED:
      return Object.assign({}, state, {
        lessonEntry: {loading: false, error: action.error}
      });
    case UPDATE_APPLICANT:
      return Object.assign({}, state, {
        loading: true,
        success: false
      });
    case UPDATE_APPLICANT_SUCCESS:
      return Object.assign({}, state, {
        selectedApplicant: {
          applicant: action.applicant,
          loading: false },
        loading: false,
        error: undefined,
        success: true
      });
    case UPDATE_APPLICANT_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: action.error,
        success: false
      });
    case UPDATE_LESSON_ENTRIES_LIST:
      return Object.assign({}, state, {
        selectedApplicant: {
          applicant: {
            ...state.selectedApplicant.applicant,
            lessonEntries: action.lessonEntries
          }
        }
      });
    case RESET_LESSON_ENTRY:
      return Object.assign({}, state, {
        lessonEntry: initialState.lessonEntry
      });
    case UPDATE_LESSON_VISIBILITY:
      return Object.assign({}, state, {lessonVisibility : Object.assign({}, state.lessonVisibility, action.lessonVisibility)});
    case RESET:
      return initialState;
    case SELECT_LESSON_ENTRY:
      return Object.assign({}, state, {lessonEntry: Object.assign({}, state.lessonEntry, {selectedEntry: action.selectedLesson})});
    default:
      return state;
  }
}

// Actions
export function resetWorkItem() {
  return {type: RESET};
}

export function resetLessonEntry() {
  return {type: RESET_LESSON_ENTRY};
}

export function getApplicantAction(id, course) {
  return {type: GET_APPLICANT, id, course};
}

export function getApplicantSuccess(applicant, course) {
  return {type: GET_APPLICANT_SUCCESS, applicant, course};
}

export function getApplicantFailed(error) {
  return {type: GET_APPLICANT_FAILED, error};
}

export function updateApplicantAction(applicantId, payload) {
  return {type: UPDATE_APPLICANT, applicantId, payload};
}

export function updateApplicantSuccess(applicant) {
  return {type: UPDATE_APPLICANT_SUCCESS, applicant: applicant};
}

export function updateApplicantFailed(error) {
  return {type: UPDATE_APPLICANT_FAILED, error};
}

export function updateLessonEntryAction(data, originalEntries, applicantId) {
  return {type: UPDATE_LESSON_ENTRY, data, originalEntries, applicantId: applicantId};
}

export function updateLessonEntrySuccess() {
  return {type: UPDATE_LESSON_ENTRY_SUCCESS};
}

export function updateLessonEntryFailed(error) {
  return {type: UPDATE_LESSON_ENTRY_FAILED, error};
}

export function updateDrivingLessonEntryAction(data, originalEntries) {
  return {type: UPDATE_DRIVING_LESSON_ENTRY, data, originalEntries};
}

export function updateDrivingLessonEntrySuccess() {
  return {type: UPDATE_DRIVING_LESSON_ENTRY_SUCCESS};
}

export function updateDrivingLessonEntryFailed(error) {
  return {type: UPDATE_DRIVING_LESSON_ENTRY_FAILED, error};
}

export function removeLessonEntryAction(applicantId, lessonEntryId, originalEntries) {
  return {type: REMOVE_LESSON_ENTRY, applicantId, lessonEntryId, originalEntries};
}

export function removeLessonEntrySuccess() {
  return {type: REMOVE_LESSON_ENTRY_SUCCESS};
}

export function removeLessonEntryFailed(error) {
  return {type: REMOVE_LESSON_ENTRY_FAILED, error};
}

export function updateLessonEntriesList(lessonEntries) {
  return {type: UPDATE_LESSON_ENTRIES_LIST, lessonEntries};
}

export function selectLessonEntryAction(selectedLesson) {
  return {type: SELECT_LESSON_ENTRY, selectedLesson: selectedLesson};
}

export function updateLessonVisibilityAction(visibility) {
  return {type: UPDATE_LESSON_VISIBILITY, lessonVisibility: visibility}
}

const mergeCourseData = (applicant, course) => {
  if (course) {
    const courseMatches = matchCourse(course);
    const courseData = applicant.applicantCourses.find(ac => courseMatches(ac.course));
    return Object.assign({}, applicant, courseData);
  }
  return applicant;
}

// Sagas
export function* handleGetApplicantSaga(action) {
  try {
    const options = {
      contentType: 'application/json',
    };
    const applicant = yield call(getApplicantById, action.id, options);
    const applicantAndCourseDetails = mergeCourseData(applicant, action.course);
    yield put(getApplicantSuccess(applicantAndCourseDetails, action.course));
  } catch (error) {
    yield put(getApplicantFailed(error));
    if (error.message === 'Unauthorized')
      yield put(showModal('LOGIN'));
  }
}

export function* handleUpdateLessonEntrySaga(action) {
  try {
    const options = {
      contentType: 'application/json',
      queryParams: {
        lessonStatus: action.data.lessonStatus
      }
    };
    const newDateString = action.data.newDate.format('YYYY-MM-DD');
    const lessonEntryEntityId = action.data.lessonEntryEntityId;
    const payload = action.data.newLesson;

    const updatedLessonEntry = yield call(updateLessonEntry, lessonEntryEntityId, newDateString, payload, options); // Change the whole lesson of then entry and return it (entry) here
    yield put(updateLessonEntrySuccess());
    yield put(hideModal());
    const modalProps = {
      messageType: 'SUCCESS',
      message: I18n.t('message.update_lesson_entry_success')
    };
    yield put(showModal('MESSAGE', modalProps));
    const updatedEntries = getUpdatedEntryList(updatedLessonEntry, action.originalEntries);
    yield put(updateLessonEntriesList(updatedEntries));
    const applicant = yield call(getApplicantById, action.applicantId, options);
    yield put(getApplicantSuccess(applicant));
  } catch (error) {
    yield put(updateLessonEntryFailed('message.update_lesson_entry_error'));
    if (error.message === 'Unauthorized')
      yield put(showModal('LOGIN'));
  }
}

export function* handleUpdateDrivingLessonEntrySaga(action) {
  try {
    const options = {
      contentType: 'application/json',
      queryParams: {
        lessonStatus: action.data.lessonStatus
      }
    };
    const lessonEntryEntityId = action.data.lessonEntryEntityId;
    const payload = parseLessonData(action.data.newLesson);

    const updatedLessonEntry = yield call(updateDrivingLessonEntry, lessonEntryEntityId, payload, options); // Change the whole lesson of then entry and return it (entry) here
    yield put(updateDrivingLessonEntrySuccess());
    yield put(hideModal());
    const modalProps = {
      messageType: 'SUCCESS',
      message: I18n.t('message.update_lesson_entry_success')
    };
    yield put(showModal('MESSAGE', modalProps));
    const updatedEntries = getUpdatedEntryList(updatedLessonEntry, action.originalEntries);
    yield put(updateLessonEntriesList(updatedEntries));
  } catch (error) {
    yield put(updateDrivingLessonEntryFailed('message.update_lesson_entry_error'));
  }
}

export function* handleRemoveLessonEntrySaga(action) {
  try {
    const options = {
      contentType: 'application/json',
    };
    yield call(removeLessonEntry, action.applicantId, action.lessonEntryId, options);
    yield put(removeLessonEntrySuccess());
    yield put(hideModal());
    const modalProps = {
      messageType: 'SUCCESS',
      message: I18n.t('message.remove_lesson_entry_success')
    };
    yield put(showModal('MESSAGE', modalProps));
    const updatedEntries = getFilteredEntryList(action.lessonEntryId, action.originalEntries);
    yield put(updateLessonEntriesList(updatedEntries));
  } catch (error) {
    yield put(removeLessonEntryFailed('message.remove_lesson_entry_error'));
    if (error.message === 'Unauthorized')
      yield put(showModal('LOGIN'));
  }
}

export function* handleUpdateApplicantSaga(action) {
  try {
    const options = {
      contentType: 'application/json',
    };
    yield call(updateApplicant, action.applicantId, action.payload, options);
    const applicant = yield call(getApplicantById, action.applicantId, options);
    const applicantAndCourseDetails = mergeCourseData(applicant, action.payload.course);
    
    yield put(updateApplicantSuccess(applicantAndCourseDetails));
  } catch (error) {
    yield put(updateApplicantFailed(error));
    if (error.message === 'Unauthorized')
      yield put(showModal('LOGIN'));
  }
}

function* watchWorkItem() {
  yield takeEvery(GET_APPLICANT, handleGetApplicantSaga);
  yield takeEvery(UPDATE_LESSON_ENTRY, handleUpdateLessonEntrySaga);
  yield takeEvery(UPDATE_DRIVING_LESSON_ENTRY, handleUpdateDrivingLessonEntrySaga);
  yield takeEvery(REMOVE_LESSON_ENTRY, handleRemoveLessonEntrySaga);
  yield takeEvery(UPDATE_APPLICANT, handleUpdateApplicantSaga);
}

export function* workItemSagas() {
  yield all([
    watchWorkItem(),
  ]);
}

// Helper function
function parseLessonData (lesson) {
  if(!!lesson) {
    const lessonDateString = lesson.lessonDate.format('YYYY-MM-DD');

    return {
      lessonStartTime: moment(`${lessonDateString} ${lesson.startTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf(),
      lessonEndTime: moment(`${lessonDateString} ${lesson.endTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf(),
      additionalInfo: lesson.additionalInfo,
      beneficialDriving: lesson.beneficialDriving,
      examClass: lesson.class,
      kilometrage: lesson.kilometrage,
      plateNumber: lesson.plateNumber,
      lessonType: lesson.subject.lessonType,
      lessonId: lesson.subject.lessonId,
      selected: lesson.subject.selected,
      entityId: lesson.subject.entityId,
      description: lesson.subject.description,
      drivingTopicCodes: lesson.drivingTopicCodes,
      lessonPauses: lesson.lessonPauses.map((lp) => {
        return {
          lessonPauseType: lp.selectedPauseType,
          pauseStartTime: moment(`${lessonDateString} ${lp.pauseStartTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf(),
          pauseEndTime: moment(`${lessonDateString} ${lp.pauseEndTime.replace('.', ':')}`, 'YYYY-MM-DD HH:mm').valueOf()
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/ducks/workItem.js